import Vue from 'vue'
import Head from './head'
import Footer from './footer'
import Slide from './slide'
import SearchBar from './search-bar'
import CountTime from './count-time'

// 全局组件在此注册
Vue.component('Head', Head)
Vue.component('Footer', Footer)
Vue.component('Slide', Slide)
Vue.component('search-bar', SearchBar)
Vue.component('count-time', CountTime)



// WEBPACK FOOTER //
// ./src/components/index.js